<template>
  <div style="width:100%;padding-top: 60px">
    <div style="position: fixed;top: 0px;z-index: 999;width: 100%; background-color:#fff;">
      <div style="text-align:center">
        <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="show" v-if="inputForm.isDoTask">
          办理
        </van-button>
        <van-button type="info" size="small" style="margin-left: 3%;width: 15%;" @click="close">返回</van-button>
      </div>

      <div class="doTask" v-if="isshow">
        <div>
          <van-field name="radio" label="审批意见">
            <template #input>
              <van-radio-group v-model="auditForm.status" direction="horizontal">
                <van-radio name="同意">同意</van-radio>
                <van-radio name="不同意">不同意</van-radio>
              </van-radio-group>
            </template>
          </van-field>
        </div>
        <div>
          <van-cell-group>
            <van-field v-model="auditForm.message" rows="2" autosize label="审批说明" type="textarea"
                       placeholder="请输入审批说明"/>
          </van-cell-group>
        </div>
        <div style="text-align:center">
          <van-button type="info" size="small" style="width: 15%;margin-top: 2%;" @click="submitTask()">提交
          </van-button>
        </div>
      </div>
    </div>

    <van-collapse v-model="activeNames">
      <!-- 基本信息 -->
      <div style="padding-left: 16px">
        <van-field v-model="inputForm.code" label="报检单编号" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.customsName" label="申请受理机关" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.createByName" label="制单人" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.createDate" label="制单日期" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
      </div>
      <van-collapse-item title="报检信息" name="1">
        <van-field v-model="inputForm.declarationTypeLabel" label="报检类型" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.entrustCompanyName" label="委托报检合同编号" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>

        <van-field v-model="inputForm.entrustCompanyName" label="委托报检公司名称" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.entrustCompanyCode" label="申请单位登记号" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.inspectionCode" label="检验检疫申请单编号" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.officeContactPersonName" label="报检联系人" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.officeContactPersonPhone" label="联系方式" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.applyDate" label="报检申请日期" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.consignorName" label="发货人" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.consigneeName" label="收货人" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.productName" label="货物名称(中/外文)" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.hsCode" label="海关H.S.编码" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.origin" label="产地" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.weight" :formatter="formatter" label="数/重量（kg)" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.productValue" :formatter="formatter" label="货物总值（美元）" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.packageTypeNum" label="包装种类及数量" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.transportToolCode" label="运输工具名称号码" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.tradeMode" label="贸易方式" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.storagePlace" label="货物存放地点" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.contractCode" label="贸易合同号" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.purpose" label="用途" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.tradingCountryName" label="输往国家（地区）" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.departurePortName" label="离境口岸" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.arrivalPortName" label="到达口岸" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.prodUnitRegCode" label="生产单位注册号" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.markCode" label="标记及号码" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
      </van-collapse-item>
      <van-collapse-item title="报检结果" name="2">
        <van-field v-model="inputForm.electronicAccountCode" label="电子底账数据号" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.inspectionCertCode" label="植物检验检疫证书编号" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
        <van-field v-model="inputForm.originCertCode" label="原产地证书编号" label-width="130px" readonly
                   input-align="left" :border="false" autosize rows="1" type="textarea"/>
      </van-collapse-item>

      <van-collapse-item title="报检费用" name="4">
        <b-table class="bgc-dark" head-variant="dark" responsive bordered
                 :items="inputForm.detailList" :fields="fields1" foot-clone>
          <template v-slot:head()="scope">
            <div class="text-nowrap" style="text-align:center; vertical-align: middle;">
              {{ scope.label }}
            </div>
          </template>
          <template v-slot:cell(index)="data">
            {{ data.index + 1 }}
          </template>
          <template v-slot:cell(amount)="data">
            {{ Number(data.item.amount).toFixed(2) }}
          </template>
          <template v-slot:cell(remark)="data">
            <div style="color: #4caedc" @click="showDetail(data.item.remark)">{{ data.item.remark }}</div>
          </template>

          <template v-slot:table-colgroup="scope">
            <col
                v-for="field in scope.fields"
                :key="field.key"
                :style="{ width: field.width }"
            >
          </template>
          <template v-slot:foot()="scope">
            <div class="text-nowrap" :style="{textAlign:'center'}"></div>
          </template>
          <template v-slot:foot(index)="data">
            <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">合计</div>
          </template>
          <template v-slot:foot(amount)="data">
            <div class="text-nowrap" :style="{textAlign:'center',fontSize:'12px'}">{{ sumNum(inputForm.detailList, 'amount') }}</div>
          </template>
        </b-table>
        <div style="padding-left: 16px; font-size: 14px;" v-show="inputForm.statementAttachList.length > 0">
          <p style="color: #AAA">对账单附件</p>
          <p style="display: block; color: #4caedc" v-for="(file,index) in inputForm.statementAttachList" :key="index"
             @click="$viewAttach(file)">{{ file.name }}</p>
        </div>
        <van-field v-model="inputForm.remark" label="备注" label-width="130px" readonly input-align="left"
                   :border="false" autosize rows="1" type="textarea"/>
      </van-collapse-item>
    </van-collapse>
    <process-record :procInsId="procInsId"></process-record>
  </div>
</template>

<script>
import processRecord from "../../../../../components/processRecord/processRecord.vue";
import TaskService from "../../../../../api/flowable/TaskService";
import ProcessService from "../../../../../api/flowable/ProcessService";
import QueryInfoService from "@/api/system/queryInfoService";
import {Decimal} from "decimal.js";

export default {
  name: "ItsCustomsDecleration",
  data() {
    return {
      activeNames: ['1','2','3','4'],
      isshow: false,
      radio: '',
      auditForm: {
        message: '',
        type: '_flow_agree',
        status: '同意',
        userIds: null,
        assignee: null
      },
      taskId: '',
      taskDefKey: '',
      procInsId: '',
      procDefId: '',
      type: '',
      inputForm: {
        statementAttachList: [],
        invoiceAttachList: [],
        exportQuarantineApplyAttachList: [],
        inspectionCertAttachList: [],
        originCertAttachList: [],
        detailList: [],
        isDoTask: false,
        isLastTask: false,
      },
      flowTable: 'its_customs_declaration',
      fields1: [
        {key: 'index', stickyColumn: true, label: '序号', width: '50px'},
        {key: 'expenseName', label: '费项名称', width: '120px'},
        {key: 'amount', label: '金额', width: '120px'},
        {key: 'remark', label: '备注', width: '120px'},
      ],
    }
  },
  components: {
    processRecord
  },
  created() {
    let query = this.$route.query;
    let id = query.id
    this.taskId = query.taskId
    this.taskDefKey = query.taskDefKey
    this.procInsId = query.procInsId
    this.procDefId = query.procDefId
    this.type = query.type || ''
    this.init(id)
  },
  methods: {
    // 合计计算
    sumNum(arr, key) {
      if (!Array.isArray(arr) || typeof key !== 'string') {
        return 0;
      }
      return arr.reduce((total, item) => {
        if (key in item) {
          const value = Number(item[key]);
          return isNaN(value) ? total : new Decimal(total).add(new Decimal(value)).toFixed(2, Decimal.ROUND_HALF_UP);
        }
        return total;
      }, 0);
    },
    show() {
      this.isshow = !this.isshow
    },
    init(id) {
      this.$flow.queryById(id, '/its/customs/itsCustomsDeclarationAmount/queryById').then(({data}) => {
        this.inputForm = data
        this.inputForm.createDate = data.createDate.slice(0, 10)
        this.getDict([
          ['customs_declaration_type', 'declarationType']
        ])
        // if (!data.exportQuarantineApplyAttachIds) {
        //   this.inputForm.exportQuarantineApplyAttachList = []
        // }
        // if (!data.inspectionCertAttachIds) {
        //   this.inputForm.inspectionCertAttachList = []
        // }
        // if (!data.originCertAttachIds) {
        //   this.inputForm.originCertAttachList = []
        // }
        // if (!data.statementAttachIds) {
        //   this.inputForm.statementAttachList = []
        // }
      }).catch(e => {
        console.log(e)
      })
    },
    // 数据字典获取
    getDict(dicts) {
      dicts.map(([dictType, formField]) => {
        new QueryInfoService().getDictMap().then(({data}) => {
          this.$set(this.inputForm, `${formField}Label`, data[dictType].find(item => item.value == this.inputForm[formField]).label);
        }).catch(e => {
          console.log(e)
        })
      })
    },
    close() {
      if (this.type !== '') {
        this.$router.back()
      } else {
        //Android、iOS支持PC不支持
        dd.biz.navigation.close({
          onSuccess: function (result) {
          },
          onFail: function (err) {
          }
        })
        // //Android、iOS不支持，PC支持
        dd.biz.navigation.quit({
          message: "quit message",
          onSuccess: function (result) {
          },
          onFail: function () {
          }
        })
      }
    },
    submitTask() {
      if (this.auditForm.status == '同意') {
        this.agree()
      } else {
        this.reject()
      }
    },
    agree() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        let vars = {}
        // vars = { ...vars, ..._this.inputForm }
        // _this.auditForm.message = _this.inputForm.remarks
        _this.auditForm.type = _this.inputForm.isLastTask ? '_flow_approval' : '_flow_agree'
        new TaskService().audit({
          taskId: _this.taskId,
          taskDefKey: _this.taskDefKey,
          procInsId: _this.procInsId,
          procDefId: _this.procDefId,
          vars: vars,
          comment: _this.auditForm,
          assignee: _this.auditForm.assignee
        }).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          let form = {
            id: _this.inputForm.id,
            flowType: _this.inputForm.isLastTask ? 4 : 2,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          // _this.inputForm.flowType = _this.inputForm.isLastTask?4:2;
          _this.$flow.startFlow(form, '/its/customs/itsCustomsDeclarationAmount/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    reject() {
      let _this = this
      _this.$dialog.confirm({
        title: '系统提醒',
        message: '您确认提交吗？',
      }).then(() => {
        _this.$toast.loading({
          message: '加载中...',
          forbidClick: true,
        });
        new ProcessService().stop(_this.procInsId, _this.auditForm.message).then(({data}) => {
          _this.$toast.clear();
          _this.$toast.success('提交成功');
          //更新数据库状态
          // _this.inputForm.flowType = 3;
          let form = {
            id: _this.inputForm.id,
            flowType: 3,
            formKey: _this.formKey,
            flowTable: _this.flowTable,
          }
          _this.$flow.startFlow(form, '/its/customs/itsCustomsDeclarationAmount/startFlow');

          setTimeout(function () {
            _this.close()
          }, 800)
        })
      }).catch(() => {
      })
    },
    formatter(value) {
      return Number(value).toFixed(2)
    },
    showDetail(content) {
      if (content === '') {
        return
      }
      this.$dialog.alert({
        message: content,
        confirmButtonColor: '#409EFF'
      })
    },
  }
}
</script>

<style scoped>

</style>